export const selectionTypes = {
    GROUP: 'groups',
    GROUPMULTIPLE: 'groupmultiple',
    CAMPAIGN: 'campaign',
    CHANNEL: 'channel',
    MESSAGESQUEUE: 'messagesqueue',
    CAMPAIGNMULTIPLE: 'campaignmultiple'
};

export const channels = [
    { id: "", name: "all2" },
    { id: "chat", name: "Chat" },
    { id: "facebook", name: "Facebook" },
    { id: "instagram", name: "Instagram" },
    { id: "twitter", name: "Twitter" },
    { id: "whatsapp", name: "Whatsapp" },
    { id: "sms", name: "SMS" },
    { id: "rainbow", name: "Rainbow" },
    { id: "telegram", name: "Telegram" },
    { id: "mail", name: "Mail" },
    { id: "call", name: "calls" }
];

export const statusColors = {
    "free": "success",
    "loggedout": "secondary",
    "paused": "danger",
    "wrapup": "warning"
};
export const hourFormat = "HH:mm";



